import DataItem from './DataItem';
import './InstallationLocationBuildingDetailInfo.scss';
import { Typography } from 'antd';
import { useTranslation } from '../../../i18n/i18n';
import EditBuilding from './EditBuilding';
import { InstallationLocationBuildingFormValues } from './FormBuildingData';
import useAuthStore from '../../../stores/auth.store';

const { Title } = Typography;

interface InstallationLocationBuildingDetailInfoProps {
  name: string;
  erpId: string;
  numberOfApartments?: number;
  numberOfFloors?: number;
  numberOfCommercialUnits?: number;
  buildingAreaM2?: number;
  averageAge?: number;
  numberOfPeople?: number;
  roofAreaM2?: number;
  hasRainwaterHarvesting?: boolean;
  adminUuid?: string;
  onSave: (values: InstallationLocationBuildingFormValues) => Promise<void>;
}

const formatNumber = (value?: number | null): string => (value == null || Number.isNaN(value) ? '-' : value.toString());

const InstallationLocationBuildingDetailInfo = (props: InstallationLocationBuildingDetailInfoProps) => {
  const { t } = useTranslation('installation-location', { keyPrefix: 'installationLocationDetail' });
  const isSuperAdminOrCompanyAdmin = useAuthStore((state) => state.isSuperAdminOrCompanyAdmin);
  const isAdmin = useAuthStore((state) => state.isAdmin);
  const userUuid = useAuthStore((state) => state.uuid);
  const isAdminOfLocation = isAdmin && userUuid === props.adminUuid;

  return (
    <div className={'InstallationLocationDetailPage__generalData'}>
      <div className={'InstallationLocationDetailPage__generalInfo__titleArea'}>
        <Title level={4} className={'InstallationLocationDetailPage__generalData__title'}>
          {t('buildingData')}
        </Title>
        {(isSuperAdminOrCompanyAdmin || isAdminOfLocation) && (
          <EditBuilding
            numberOfApartments={props.numberOfApartments}
            numberOfFloors={props.numberOfFloors}
            numberOfCommercialUnits={props.numberOfCommercialUnits}
            buildingAreaM2={props.buildingAreaM2}
            averageAge={props.averageAge}
            numberOfPeople={props.numberOfPeople}
            roofAreaM2={props.roofAreaM2}
            hasRainwaterHarvesting={props.hasRainwaterHarvesting}
            onSave={props.onSave}
          />
        )}
      </div>
      <div className={'InstallationLocationDetailPage__generalData__rows'}>
        <div className={'InstallationLocationDetailPage__generalData__rows__column'}>
          <DataItem title={t('numPeople')} data={formatNumber(props.numberOfPeople)} />
          <DataItem title={t('avgAge')} data={formatNumber(props.averageAge)} extra={t('years')} />
          <DataItem title={t('riverCollecting')} data={''} waterHarvesting={props.hasRainwaterHarvesting} />
        </div>
        <div className={'InstallationLocationDetailPage__generalData__rows__column'}>
          <DataItem title={t('floorsNum')} data={formatNumber(props.numberOfFloors)} />

          <DataItem title={t('flatNum')} data={formatNumber(props.numberOfApartments)} />
          <DataItem title={t('locals')} data={formatNumber(props.numberOfCommercialUnits)} />
        </div>
        <div className={'InstallationLocationDetailPage__generalData__rows__column'}>
          <DataItem title={t('squaredMeters')} data={formatNumber(props.buildingAreaM2)} extra={t('metersSquared')} />

          <DataItem title={t('squaredMetersRoof')} data={formatNumber(props.roofAreaM2)} extra={t('metersSquared')} />
        </div>
      </div>
    </div>
  );
};

export default InstallationLocationBuildingDetailInfo;
